import { render, staticRenderFns } from "./HKStockDetail.vue?vue&type=template&id=1964ece9"
import script from "./HKStockDetail.vue?vue&type=script&lang=js"
export * from "./HKStockDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports